var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.43747 0.20816C3.72085 0.20816 0.70813 3.22088 0.70813 6.9375C0.70813 10.6541 3.72085 13.6668 7.43747 13.6668C9.04025 13.6668 10.5123 13.1064 11.6683 12.1708L14.2704 14.7729C14.4033 14.9058 14.5835 14.9804 14.7714 14.9804C14.9593 14.9804 15.1395 14.9058 15.2723 14.7729C15.4052 14.64 15.4799 14.4598 15.4799 14.2719C15.4799 14.084 15.4052 13.9038 15.2723 13.771L12.6703 11.1689C13.6408 9.97244 14.1693 8.47808 14.1668 6.9375C14.1668 3.22088 11.1541 0.20816 7.43747 0.20816ZM2.12497 6.9375C2.12497 4.00341 4.50338 1.625 7.43747 1.625C10.3716 1.625 12.75 4.00341 12.75 6.9375C12.75 9.8716 10.3716 12.25 7.43747 12.25C4.50338 12.25 2.12497 9.8716 2.12497 6.9375Z",
    fill: "#F3F3F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.bc82fec251d0919930095a2fcdb283cd.svg";
export { ForwardRef as ReactComponent };